module.exports = __webpack_public_path__ + "img/ofline.8e0dd599.svg";